import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { ListItem, ListItemText } from '@material-ui/core';
import { useUser } from '../contexts/user-context';
import { SignOutMutation } from '../mutations/SignOut';

export const SignOutButton = () => {
  // Mutation to handle sign out
  // This will clear the auth token and user data from local storage
  // and reset the user context state.

  const { signOut } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [sendSignOut, { data, error, client }] = useMutation(SignOutMutation);

  useEffect(() => {
    if (error || data) {
      if (error) {
        console.error('Sign out error:', error);
      }
      signOut(); // Clear user context and local storage
      client.clearStore(); // Clear Apollo Client cache
      navigate('/signin', { state: { from: location } }); // Redirect to sign-in page
    }
  }, [error, data, signOut, navigate, client, location]);

  return (
    <ListItem button component="a" href="#" onClick={sendSignOut}>
      <ListItemText primary="Sign Out" />
    </ListItem>
  );
};
